import { render, staticRenderFns } from "./TrademarkRegistration.vue?vue&type=template&id=4abbb191&scoped=true"
import script from "./TrademarkRegistration.vue?vue&type=script&lang=js"
export * from "./TrademarkRegistration.vue?vue&type=script&lang=js"
import style0 from "./TrademarkRegistration.vue?vue&type=style&index=0&id=4abbb191&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abbb191",
  null
  
)

export default component.exports